import { Injectable } from "@angular/core";
import { DataStoreService } from '../../core/services/data-store.service';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TranslateLanguage } from '../model/translate-language.model';
@Injectable({ providedIn: "root" })
export class ParagraphUtil {
    private allLang: TranslateLanguage[];
    
    private currentLangCode: string;
    private currentLang: TranslateLanguage;

    constructor(private dataStoreService: DataStoreService, 
        private activatedRoute: ActivatedRoute,
        private translateService: TranslateService) {

        this.dataStoreService.languages$.subscribe((langs) => {
            this.allLang = langs;
        });
        
        this.activatedRoute.queryParams.subscribe((params) => {
            this.currentLangCode = params["lang"] ? params["lang"] : "en";
            console.log("queryParamsChange: " + this.currentLangCode);
            this.updateCurrentLang();
        });
    
        
        this.translateService.onLangChange.subscribe((event) => {
            this.currentLangCode = event.lang ? event.lang : "en";
            console.log("onLangChange: " + this.currentLangCode);
            this.updateCurrentLang();
        });
    }

    getTranslation(key: string, val1: string = null): string{
        var res: string = null;
        if(this.currentLang && this.currentLang.paragraphs){
            var paragraph = this.currentLang.paragraphs.find(p => p.paragraphKey == key);
            if(paragraph) res = paragraph.description;
            if(val1 && res) res = res.replace("{1}", val1);
        }
        return res;
    }

    private updateCurrentLang(){
        if(this.allLang) {
            this.currentLang = this.allLang.find(l => l.languageCode.toUpperCase() == this.currentLangCode.toUpperCase())
        }
    }

    
  
}
